// Утилиты для работы с localStorage с поддержкой реактивности

export function setReactiveLocalStorage(key, value) {
  localStorage.setItem(key, value);

  // Отправляем кастомное событие для обновления в том же окне
  window.dispatchEvent(
    new CustomEvent('localStorageUpdate', {
      detail: { key, value },
    })
  );
}

export function removeReactiveLocalStorage(key) {
  localStorage.removeItem(key);

  // Отправляем кастомное событие для обновления в том же окне
  window.dispatchEvent(
    new CustomEvent('localStorageUpdate', {
      detail: { key, value: null },
    })
  );
}
